import { DatePickerChips } from 'cdk-radial';
import moment, { Moment } from 'moment';
import { useIntl } from 'react-intl';
import { RDS_DATE_PICKER_SHOW_ONE_MONTH } from 'common/constants';
import { formattedDate, getDateFormatByLocale } from 'utils/dateUtils';
import { DatePickerChipType } from './types';

export const DatePickerChip = ({
  label,
  settledDate,
  setSettledDate
}: DatePickerChipType): React.JSX.Element => {
  const intl = useIntl();
  const displayDate = getDateFormatByLocale(intl.locale);
  const momentDueDate = settledDate ? moment(settledDate) : null;

  const handleDateChange = (date: Moment | null) =>
    setSettledDate(formattedDate(date?.toISOString() as string));

  const onRemove = () => setSettledDate('');

  return (
    <DatePickerChips
      allowDaysInPast
      date={momentDueDate}
      dataTestId="date-picker-chip"
      dateFormat={displayDate}
      id="date-picker-chip"
      label={intl.formatMessage(label)}
      numberOfMonths={RDS_DATE_PICKER_SHOW_ONE_MONTH}
      onDateChange={handleDateChange}
      onRemove={onRemove}
    />
  );
};
